import queryString from "query-string";
import services from "../../../../services";
import $ from 'jquery';

let data = [];

const generateId = data =>
    data.reduce((acc, current) => Math.max(acc, current.ProductID), 0) + 1;

export const insertItem = item => {
    item.ProductID = generateId(data);
    item.inEdit = false;
    item.IDAutoDetalhe = 0;
    item.Columns = [];
    data.unshift(item);
    return data;
};

export const deleteAll = () => {
    data = [];
    return data;

};
export const dataGet8 = async () => {
    return data;
};

export const getItems8 = async () =>  {
    console.log("services3")
    if(window.location.search != ""){
        var queryParams = queryString.parse(window.location.search)
        var  token = queryParams.idAuto
        var  dataToken = {"idAuto": token}
        var Detalhes = await services.apiCall.requestApi(
            "/Fiscalizacao/GetAutoDetalhe",
            dataToken,
            "get"
        ); 
            for (let i = 0; i < Detalhes.autoGridGranel.length ; i++) {
                var RegistoProduto1 =  Detalhes.autoGridGranel[i].contaCorrenteDesc;
                var Correlativa1 = Detalhes.autoGridGranel[i].correlativa;
                var NLote1 = Detalhes.autoGridGranel[i].numeroLote;
                var NGarrafas1 = Detalhes.autoGridGranel[i].numeroGarrafasAE;
                var Capacidade1 = Detalhes.autoGridGranel[i].capacidadeAE;
                var TotalQBD1 = Detalhes.autoGridGranel[i].quantidadeAferida;
                var idContaCorrente1 =  Detalhes.autoGridGranel[i].idContaCorrente;
                var idRegistoProduto1 = Detalhes.autoGridGranel[i].idRegistoProduto;
                var idCapacidadeAE1 = Detalhes.autoGridGranel[i].idCapacidadeAE;
                var idAutoDetalhe1 = Detalhes.autoGridGranel[i].idAutoDetalhe;
                var idRotulo1 = Detalhes.autoGridGranel[i].idRotulo;
                data.push({ 
                    RegistoProduto : RegistoProduto1,
                    Correlativa : Correlativa1,
                    NLote : NLote1,
                    NGarrafas : NGarrafas1,
                    CapacidadeND : Capacidade1,
                    TotalQBD : TotalQBD1,
                    ProductID: i,
                    idContaCorrente : idContaCorrente1,
                    idRegistoProduto: idRegistoProduto1,
                    idCapacidadeAE: idCapacidadeAE1,
                    idAutoDetalhe: idAutoDetalhe1,
                    idRotulo: idRotulo1,
                    Discontinued: false,
                    Columns: [],
                    inEdit: false
                })
            }
            return data;
        
    }else{
         return data
    }
    
};

export const updateItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data[index] = item;
    return data;
};

export const deleteItem = item => {
    let index = data.findIndex(record => record.ProductID === item.ProductID);
    data.splice(index, 1);
    return data;
};
